<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Texto</label>
            <input class="form-control" type="text" :value="modelValue.text"
                @input="update('text', $event.target.value)">
        </div>
        <div class="mb-3">
            <label class="form-label">URL</label>
            <input class="form-control" type="text" :value="modelValue.url"
                @input="update('url', $event.target.value)">
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Fondo</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.backgroundColor"
                        @input="update('backgroundColor', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.backgroundColor || '#0d6efd'"
                        @input="update('backgroundColor', $event.target.value)">
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Color texto</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.textColor"
                        @input="update('textColor', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.textColor || '#ffffff'"
                        @input="update('textColor', $event.target.value)">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding"
                    @input="update('padding', $event.target.value)">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Border radius</label>
                <input class="form-control" type="text" :value="modelValue.borderRadius"
                    @input="update('borderRadius', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <label class="form-label">Font size</label>
                <input class="form-control" type="text" :value="modelValue.fontSize"
                    @input="update('fontSize', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Font family</label>
                <input class="form-control" type="text" :value="modelValue.fontFamily"
                    @input="update('fontFamily', $event.target.value)">
            </div>
            <div class="col-md-4 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockButtonEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
